import { I18nUtils } from '@modules/I18nUtils.js'
import './assets/css/predefined.css'
import '@static/consts/index'
import '@new-crm/events-editor/dist/events-editor.iife.js'

const defaultDatetimeFormat = {
  short: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },

  long: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
}

const i18n = I18nUtils.setupI18n( {
  locale: 'en',
  datetimeFormats: {
    'en': defaultDatetimeFormat,
    'ru': defaultDatetimeFormat,
    'es': defaultDatetimeFormat,
  },
} as any )
import( './app' )

export {
  i18n,
}
